import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import MuiLink from '@material-ui/core/Link';
import SkeletonBody from '@afosto/components-react/SkeletonBody';
import { dataset as datasetApi } from '@afosto/content/api/Dataset';

const BASE_URL = process.env.REACT_APP_BASE_APP_URL;
const FILES_APP_ORIGIN = BASE_URL.replace('{app}', 'files');

const DatasetFormatter = ({ datasetId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [dataset, setDataset] = useState(null);
  const isSameOrigin = window.location.origin === FILES_APP_ORIGIN;

  useEffect(() => {
    let isMounted = true;

    const fetchDataset = async id => {
      setIsLoading(true);

      try {
        const response = await datasetApi.getDataset(id);
        const { data = null } = response;

        if (isMounted) {
          setDataset(data);
        }
      } catch (err) {
        if (isMounted) {
          setDataset(null);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    if (datasetId && datasetId !== '') {
      fetchDataset(datasetId);
    }

    return () => {
      isMounted = false;
    };
  }, [datasetId]);

  if (isLoading) {
    return <SkeletonBody lines={1} />;
  }

  if (!dataset) {
    return <Typography variant="body2">-</Typography>;
  }

  if (isSameOrigin) {
    return (
      <MuiLink variant="subtitle1" component={Link} to={`/datasets/${datasetId}`}>
        {dataset?.reference ?? '-'}
      </MuiLink>
    );
  }

  return (
    <MuiLink variant="subtitle1" href={`${FILES_APP_ORIGIN}/datasets/${datasetId}`}>
      {dataset?.reference ?? '-'}
    </MuiLink>
  );
};

DatasetFormatter.propTypes = {
  datasetId: PropTypes.string,
};

DatasetFormatter.defaultProps = {
  datasetId: undefined,
};

export default DatasetFormatter;
